export interface GermanSectorIconTranslation {
    label: string;
    aliases: string;
}

const de = (label: string, aliases: string): GermanSectorIconTranslation => ({label, aliases});

export const GERMAN_SECTOR_ICON_TRANSLATIONS: Record<string, GermanSectorIconTranslation> = {
    "default": de("Standard", "vorgabe voreinstellung standardwert ersatz"),
    "accessibility": de("Barrierefreiheit", "barrierefrei rollstuhl inklusiv zugänglich"),
    "account-tree": de("Struktur", "hierarchie organigramm verbunden baum"),
    "business": de("Geschäft", "unternehmen firma laden gewerbe"),
    "shuttle": de("Shuttle", "transfer pendelbus zubringer transport"),
    "apartment": de("Apartment", "wohnung wohnhaus unterkunft gebäude"),
    "architecture": de("Architektur", "entwurf zeichnung plan bauplan"),
    "special": de("Besonders", "spezial magie glitzer außergewöhnlich"),
    "bakery": de("Bäckerei", "brot gebäck konditorei backstube"),
    "beach": de("Strand", "meer urlaub sommer sonnenschirm"),
    "bed": de("Bett", "zimmer schlafen unterkunft übernachtung"),
    "brunch": de("Brunch", "frühstück essen speisen vormittag"),
    "briefcase": de("Aktentasche", "arbeit geschäft büro koffer"),
    "cake": de("Kuchen", "torte geburtstag dessert süßspeise"),
    "calendar": de("Kalender", "agenda wochenplaner termin veranstaltung"),
    "camera": de("Kamera", "foto fotografie bild aufnehmen"),
    "castle": de("Schloss", "burg wahrzeichen gebäude palast"),
    "chair": de("Stuhl", "sitz sitzplatz tisch möbel"),
    "chalet": de("Chalet", "hütte berghütte unterkunft ferienhaus"),
    "wardrobe": de("Garderobe", "kleiderschrank kleidung umkleide miete"),
    "kids": de("Kinder", "kind familie baby jugend"),
    "child-hat": de("Kindermütze", "kind baby kinder familie mütze"),
    "cleaning": de("Reinigung", "putzen housekeeping besen sauber"),
    "coffee": de("Kaffee", "café tee getränk tasse"),
    "creative": de("Kreativ", "farbe malen kunst gestaltung"),
    "construction": de("Bauarbeiten", "bau reparatur wartung werkzeug"),
    "terrace": de("Terrasse", "deck außenbereich garten balkon"),
    "bike": de("Fahrrad", "rad radfahren cycling velo"),
    "boat": de("Boot", "schiff see wasser ausflug"),
    "bus": de("Bus", "transport transfer reisebus linienbus"),
    "car": de("Auto", "pkw parken transfer transport fahrzeug"),
    "ski": de("Ski", "skifahren winter schnee pistensport"),
    "dry-cleaning": de("Textilreinigung", "chemische reinigung wäsche kleidung bügeln"),
    "senior": de("Senior", "ältere pflege betagte senioren"),
    "trophy": de("Pokal", "trophäe auszeichnung wettbewerb gewinner"),
    "family": de("Familie", "eltern kinder haushalt"),
    "family-restroom": de("Familien-WC", "familientoilette eltern kinder wickelraum"),
    "event": de("Veranstaltung", "event termin reservierung datum"),
    "puzzle": de("Puzzle", "spiel rätsel aktivität"),
    "beauty": de("Beauty", "schönheit gesicht kosmetik pflege"),
    "restroom": de("Toilette", "wc waschraum familien-wc"),
    "fast-food": de("Fast Food", "burger imbiss snack essen"),
    "festival": de("Festival", "fest zelt veranstaltung feier"),
    "fertile": de("Fruchtbarkeit", "fruchtbar fertilität natur kinderwunsch"),
    "fitness": de("Fitness", "fitnessstudio training sport workout"),
    "flight": de("Flug", "fliegen flughafen reise flugzeug"),
    "forest": de("Wald", "natur draußen bäume forst"),
    "breakfast": de("Frühstück", "morgenkaffee brunch buffet speisen"),
    "health": de("Gesundheit", "sicherheit medizin arzt wohlbefinden"),
    "high-chair": de("Hochstuhl", "kinderstuhl baby kleinkind restaurant"),
    "hiking": de("Wandern", "spazieren berg draußen trekking"),
    "repair": de("Reparatur", "service werkzeug instandhaltung wartung"),
    "hot-tub": de("Whirlpool", "sprudelbad spa wellness jacuzzi"),
    "hotel": de("Hotel", "unterkunft zimmer aufenthalt übernachtung"),
    "ice-skating": de("Eislaufen", "schlittschuh winter sport eis"),
    "guide": de("Guide", "führer rezeption concierge begleitung"),
    "kayak": de("Kajak", "kanu wasser sport see paddeln"),
    "king-bed": de("Kingsize-Bett", "doppelbett hotelzimmer schlafen"),
    "kitchen": de("Küche", "kochen essen gastronomie herd"),
    "kitesurfing": de("Kitesurfen", "wasser wind sport drachen"),
    "landscape": de("Landschaft", "berg aussicht natur panorama"),
    "ticket": de("Ticket", "eintritt karte gutschein aktivität"),
    "bar": de("Bar", "getränk cocktail lokal nachtleben"),
    "cafe": de("Café", "kaffee tee lokal kuchen"),
    "dining": de("Essen", "speisen restaurant mahlzeit gastronomie"),
    "fireplace": de("Kamin", "feuer wärme ofen feuerstelle"),
    "nature": de("Natur", "blume garten pflanze draußen"),
    "local-hotel": de("Unterkunft", "hotel bett übernachtung zimmer"),
    "laundry": de("Wäscherei", "wäsche waschen reinigung waschsalon"),
    "library": de("Bibliothek", "bücherei lesen lernen bücher"),
    "shopping": de("Einkaufen", "shopping einkaufszentrum laden geschäft"),
    "movies": de("Kino", "film theater vorführung movies"),
    "offer": de("Angebot", "rabatt etikett aktion preisnachlass"),
    "parking": de("Parkplatz", "parken auto garage stellplatz"),
    "phone": de("Telefon", "anruf kontakt handy call"),
    "pizza": de("Pizza", "essen restaurant italienisch speise"),
    "photo": de("Foto", "kamera bild ansicht fotografie"),
    "shipping": de("Lieferung", "versand zustellung lkw transport"),
    "city": de("Stadt", "gebäude ort zentrum urban"),
    "luggage": de("Gepäck", "koffer tasche reise baggage"),
    "lunch": de("Mittagessen", "lunch speisen mittagsmenü restaurant"),
    "museum": de("Museum", "kultur galerie ausstellung kunst"),
    "music": de("Musik", "konzert klang ton unterhaltung"),
    "nightlife": de("Nachtleben", "party club feiern disco"),
    "walking": de("Spazieren", "gehen nordic walking wandern draußen"),
    "grill": de("Grill", "grillen barbecue essen bbq"),
    "palette": de("Palette", "kunst farbe kreativ malen"),
    "park": de("Park", "baum garten grünanlage natur"),
    "pedal-bike": de("Fahrrad", "pedal radfahren rad cycling"),
    "pets": de("Haustiere", "tier hund katze tierfreundlich"),
    "piano": de("Klavier", "musik instrument flügel"),
    "pool": de("Pool", "schwimmbad schwimmen wasser becken"),
    "food": de("Essen", "restaurant mahlzeit speisen gastronomie"),
    "restaurant": de("Restaurant", "gasthaus lokal gastronomie essen tisch"),
    "room-service": de("Zimmerservice", "roomservice hotel zimmer lieferung"),
    "sailing": de("Segeln", "segelboot wasser sport"),
    "school": de("Schule", "lernen klasse kurs bildung"),
    "yoga": de("Yoga", "meditation entspannung wellness achtsamkeit"),
    "shopping-bag": de("Einkaufstasche", "shopping tasche einzelhandel einkaufen"),
    "snowboard": de("Snowboard", "winter schnee sport piste"),
    "snowshoe": de("Schneeschuh", "winter schnee wandern schneeschuhwandern"),
    "spa": de("Spa", "wellness schönheit massage sauna erholung"),
    "sports": de("Sport", "aktivität bewegung training freizeit"),
    "sports-bar": de("Sportsbar", "sport bar getränk lokal"),
    "basketball": de("Basketball", "ball sport korb"),
    "esports": de("E-Sport", "gaming spiel computerspiel"),
    "football": de("American Football", "football sport ball"),
    "golf": de("Golf", "sport golfplatz abschlag"),
    "gymnastics": de("Gymnastik", "turnen bewegung sport"),
    "handball": de("Handball", "ball sport teamsport"),
    "active-sport": de("Aktivsport", "bewegung action sport aktiv"),
    "martial-arts": de("Kampfsport", "boxen kämpfen martial arts dojo"),
    "motorsport": de("Motorsport", "rennen motorrad auto racing"),
    "soccer": de("Fußball", "fussball soccer ball sport"),
    "tennis": de("Tennis", "platz schläger racket sport"),
    "surfing": de("Surfen", "wasser welle sport surfbrett"),
    "stage": de("Bühne", "theater aufführung performance veranstaltung"),
    "tour": de("Tour", "ausflug führung reise flagge"),
    "toys": de("Spielzeug", "kinder spielen games"),
    "horse": de("Pferd", "reiten stall pony reitsport"),
    "volunteer": de("Ehrenamt", "freiwillig hilfe wohltätigkeit betreuung"),
    "wine": de("Wein", "bar getränk weinglas verkostung"),
    "work": de("Arbeit", "geschäft büro job unternehmen"),
    "air-conditioning": de("Klimaanlage", "klima kühlung kalt lüftung"),
    "farm": de("Bauernhof", "landwirtschaft traktor land hof"),
    "attraction": de("Attraktion", "freizeitpark fahrgeschäft sehenswürdigkeit"),
    "badge": de("Ausweis", "namensschild mitarbeiter identifikation badge"),
    "balcony": de("Balkon", "terrasse zimmer außenbereich"),
    "bathroom": de("Badezimmer", "bad toilette waschraum"),
    "bathtub": de("Badewanne", "bad spa wellness wanne"),
    "cabin": de("Hütte", "blockhütte lodge unterkunft ferienhaus"),
    "celebration": de("Feier", "party konfetti veranstaltung fest"),
    "church": de("Kirche", "kapelle hochzeit zeremonie gotteshaus"),
    "salon": de("Salon", "friseur haarschnitt schere beauty"),
    "cottage": de("Ferienhaus", "cottage haus urlaub unterkunft"),
    "counter": de("Theke", "küchentheke arbeitsfläche tresen"),
    "diamond": de("Diamant", "luxus premium schmuck edelstein"),
    "dinner": de("Abendessen", "dinner speisen restaurant abend mahlzeit"),
    "running": de("Laufen", "joggen fitness sport rennen"),
    "electric-bike": de("E-Bike", "elektrorad fahrrad mobilität pedelec"),
    "electric-car": de("Elektroauto", "e-auto fahrzeug laden transport"),
    "scooter": de("E-Scooter", "roller mobilität transport elektrisch"),
    "engineering": de("Technik", "techniker wartung service engineering"),
    "availability": de("Verfügbarkeit", "kalender frei bestätigt termin"),
    "favorite": de("Favorit", "herz liebe liebling merken"),
    "flower": de("Blume", "garten natur pflanze blüte"),
    "flatware": de("Besteck", "gabel messer speisen restaurant"),
    "group": de("Gruppe", "personen gäste team menschen"),
    "handshake": de("Handschlag", "partnerschaft willkommen vereinbarung begrüßung"),
    "headphones": de("Kopfhörer", "audio musik hören sound"),
    "holiday-village": de("Feriendorf", "resort urlaub unterkunft ferienanlage"),
    "houseboat": de("Hausboot", "boot unterkunft wasser schwimmendes haus"),
    "key": de("Schlüssel", "zimmer zugang sicherheit schloss"),
    "liquor": de("Spirituosen", "alkohol flasche bar getränk schnaps"),
    "grocery": de("Lebensmittel", "supermarkt markt einkaufen essen"),
    "hospital": de("Krankenhaus", "klinik gesundheit notfall medizin"),
    "taxi": de("Taxi", "transfer auto transport cab"),
    "map": de("Karte", "reise ort wegweiser landkarte"),
    "medical-services": de("Medizinische Dienste", "arzt klinik gesundheit behandlung"),
    "meeting-room": de("Besprechungsraum", "konferenzraum meeting geschäft tür"),
    "microphone": de("Mikrofon", "musik rede karaoke veranstaltung"),
    "shelter": de("Unterkunft", "herberge hostel schlafplatz schutz"),
    "payment": de("Zahlung", "geld preis abrechnung kasse"),
    "people": de("Personen", "menschen gäste besucher profile"),
    "location": de("Standort", "ort pin ziel adresse"),
    "plumbing": de("Sanitär", "rohr wartung reparatur installateur"),
    "world": de("Welt", "globus international öffentlich reise"),
    "ramen": de("Ramen", "nudeln suppe asiatisch essen restaurant"),
    "invoice": de("Rechnung", "beleg abrechnung dokument folio"),
    "gift": de("Geschenk", "gutschein präsent einlösen"),
    "roller-skating": de("Rollschuhlaufen", "rollschuh sport aktivität skaten"),
    "roof": de("Dach", "haus unterkunft gebäude roofing"),
    "hygiene": de("Hygiene", "desinfektion sauber gesundheit sanitizer"),
    "scuba-diving": de("Tauchen", "scuba unterwasser sport diving"),
    "security": de("Sicherheit", "schild schutz sicher bewachung"),
    "shower": de("Dusche", "badezimmer spa wellness bad"),
    "skateboarding": de("Skateboard", "board sport aktivität skaten"),
    "cricket": de("Cricket", "schläger ball sport"),
    "hockey": de("Hockey", "eis sport schläger"),
    "rugby": de("Rugby", "ball sport teamsport"),
    "volleyball": de("Volleyball", "beach ball sport teamsport"),
    "stadium": de("Stadion", "arena sport veranstaltung"),
    "storefront": de("Ladengeschäft", "shop einzelhandel geschäft ladenfront"),
    "table-bar": de("Tisch und Bar", "restaurant sitzplatz theke gastronomie"),
    "takeaway": de("Zum Mitnehmen", "take-away abholung essen restaurant"),
    "tapas": de("Tapas", "kleine gerichte essen restaurant spanisch"),
    "buddhist-temple": de("Buddhistischer Tempel", "buddhismus meditation spirituell"),
    "hindu-temple": de("Hindu-Tempel", "hinduismus spirituell gebet"),
    "terrain": de("Gelände", "berg landschaft draußen terrain"),
    "train": de("Zug", "bahn eisenbahn transport transfer"),
    "tram": de("Straßenbahn", "tram bahn stadt transport"),
    "motorbike": de("Motorrad", "motorbike zweirad transport"),
    "villa": de("Villa", "resort haus unterkunft ferienhaus"),
    "water": de("Wasser", "see meer pool schwimmen"),
    "water-drop": de("Wassertropfen", "wasser tropfen hydration spa"),
    "waves": de("Wellen", "wasser meer ozean spa"),
    "sunny": de("Sonnig", "sonne wetter draußen sommer"),
    "lounge": de("Lounge", "sofa sitzbereich entspannen salon"),
    "wheelchair": de("Rollstuhl", "barrierefrei zugänglich inklusiv mobilität"),
    "wifi": de("WLAN", "wifi internet drahtlos verbindung wireless"),
    "premium": de("Premium", "auszeichnung qualität luxus hochwertig"),
    "mui-access-alarm": de("Wecker", "alarm uhr erinnerung zugang"),
    "mui-account-balance": de("Kontostand", "konto bank finanzen saldo"),
    "mui-account-balance-wallet": de("Geldbörse", "wallet brieftasche konto geld"),
    "mui-account-box": de("Benutzerkonto", "profil person account kontakt"),
    "mui-account-circle": de("Profil", "konto person benutzer avatar"),
    "mui-add-location-alt": de("Standort hinzufügen", "ort adresse pin neu"),
    "mui-admin-panel-settings": de("Admin-Einstellungen", "administration sicherheit konfiguration"),
    "mui-air": de("Luft", "wind lüftung klima frischluft"),
    "mui-airline-seat-flat": de("Liegesitz", "flugsitz flach schlafen sitz"),
    "mui-airline-seat-individual-suite": de("Einzelsuite", "flugzeug sitz suite kabine"),
    "mui-airline-seat-legroom-extra": de("Mehr Beinfreiheit", "sitz flugzeug komfort platz"),
    "mui-airline-seat-recline-extra": de("Verstellbarer Sitz", "lehne flugzeug komfort zurücklehnen"),
    "mui-airlines": de("Fluglinien", "airline flugzeug fliegen luftfahrt"),
    "mui-airplane-ticket": de("Flugticket", "flug karte boardingpass flugzeug"),
    "mui-all-inclusive": de("All-inclusive", "alles inklusive pauschale resort paket"),
    "mui-analytics": de("Analyse", "statistik auswertung diagramm daten"),
    "mui-anchor": de("Anker", "boot schiff hafen wasser"),
    "mui-announcement": de("Ankündigung", "meldung durchsage information megafon"),
    "mui-approval": de("Genehmigung", "freigabe bestätigt stempel zustimmung"),
    "mui-article": de("Artikel", "dokument text nachricht beitrag"),
    "mui-assist-walker": de("Rollator", "gehhilfe mobilität senior barrierefrei"),
    "mui-atm": de("Geldautomat", "atm bargeld bank abheben"),
    "mui-audio-file": de("Audiodatei", "ton musik sound datei"),
    "mui-baby-changing-station": de("Wickelstation", "baby wickeln familie kind"),
    "mui-backpack": de("Rucksack", "tasche gepäck wandern reise"),
    "mui-balance": de("Waage", "balance gerechtigkeit abwägen gewicht"),
    "mui-bento": de("Bento", "essen box japanisch mahlzeit"),
    "mui-biotech": de("Biotechnologie", "labor forschung medizin mikroskop"),
    "mui-blind": de("Blind", "sehbehindert barrierefrei zugänglich person"),
    "mui-book": de("Buch", "lesen bibliothek literatur lernen"),
    "mui-book-online": de("Online buchen", "reservierung termin internet buchung"),
    "mui-breakfast-dining": de("Frühstück", "essen morgen speisen brunch"),
    "mui-brush": de("Pinsel", "malen kunst farbe kreativ"),
    "mui-bungalow": de("Bungalow", "ferienhaus unterkunft haus resort"),
    "mui-bus-alert": de("Buswarnung", "bus hinweis transport alarm"),
    "mui-business": de("Unternehmen", "firma geschäft büro gebäude"),
    "mui-calculate": de("Berechnen", "rechner kalkulation mathematik summe"),
    "mui-calendar-today": de("Heutiger Kalender", "heute datum termin kalender"),
    "mui-calendar-view-week": de("Wochenkalender", "woche kalender agenda planer"),
    "mui-call": de("Anruf", "telefon call kontakt sprechen"),
    "mui-camera-indoor": de("Innenkamera", "kamera drinnen überwachung foto"),
    "mui-camera-outdoor": de("Außenkamera", "kamera draußen überwachung foto"),
    "mui-campaign": de("Kampagne", "marketing werbung megafon aktion"),
    "mui-car-rental": de("Autovermietung", "mietwagen auto mieten fahrzeug"),
    "mui-car-repair": de("Autoreparatur", "werkstatt auto service wartung"),
    "mui-carpenter": de("Tischler", "schreiner handwerk holz werkzeug"),
    "mui-casino": de("Casino", "spielbank glücksspiel karten chips"),
    "mui-category": de("Kategorie", "gruppe typ sortierung ordnung"),
    "mui-cell-tower": de("Mobilfunkmast", "antenne empfang netz signal"),
    "mui-chair-alt": de("Stuhl", "sitz möbel sitzplatz sessel"),
    "mui-child-friendly": de("Kinderfreundlich", "kind familie baby geeignet"),
    "mui-clean-hands": de("Saubere Hände", "hygiene waschen desinfektion sauber"),
    "mui-cloud": de("Wolke", "cloud wetter online speicher"),
    "mui-co-present": de("Präsentation", "vortrag person bildschirm schulung"),
    "mui-commute": de("Arbeitsweg", "pendeln transport fahrt reise"),
    "mui-computer": de("Computer", "pc laptop bildschirm technik"),
    "mui-confirmation-number": de("Bestätigungsnummer", "ticket buchungsnummer code reservierung"),
    "mui-contact-emergency": de("Notfallkontakt", "notfall kontakt hilfe person"),
    "mui-contact-mail": de("Kontakt per E-Mail", "mail nachricht adresse brief"),
    "mui-contact-phone": de("Telefonkontakt", "telefon anruf person kontakt"),
    "mui-contacts": de("Kontakte", "adressbuch personen kunden profile"),
    "mui-corporate-fare": de("Firmentarif", "geschäftsrate unternehmen preis business"),
    "mui-credit-card": de("Kreditkarte", "zahlung karte bezahlen bank"),
    "mui-crib": de("Babybett", "gitterbett kind baby schlafplatz"),
    "mui-dark-mode": de("Dunkelmodus", "dark mode nacht design dunkel"),
    "mui-delivery-dining": de("Essenslieferung", "lieferdienst essen zustellung restaurant"),
    "mui-design-services": de("Design-Dienste", "gestaltung kreativ entwurf service"),
    "mui-desk": de("Schreibtisch", "büro tisch arbeit möbel"),
    "mui-directions-railway": de("Bahnverbindung", "zug eisenbahn richtung transport"),
    "mui-directions-subway": de("U-Bahn-Verbindung", "metro subway richtung transport"),
    "mui-directions-walk": de("Fußweg", "gehen laufen spazieren route"),
    "mui-diversity1": de("Vielfalt", "diversität menschen inklusion gruppe"),
    "mui-diversity2": de("Gemeinschaft", "diversität personen gruppe inklusion"),
    "mui-door-front": de("Haustür", "eingang tür vorne zugang"),
    "mui-door-sliding": de("Schiebetür", "tür eingang zugang schieben"),
    "mui-doorbell": de("Türklingel", "klingel eingang besucher tür"),
    "mui-draw": de("Zeichnen", "stift malen skizze unterschrift"),
    "mui-egg": de("Ei", "frühstück essen lebensmittel"),
    "mui-elevator": de("Aufzug", "lift etage barrierefrei transport"),
    "mui-emergency-share": de("Notfallfreigabe", "notfall teilen standort hilfe"),
    "mui-emoji-emotions": de("Emotionen", "smiley gefühl gesicht glücklich"),
    "mui-emoji-food-beverage": de("Speisen und Getränke", "essen trinken kaffee gastronomie"),
    "mui-emoji-nature": de("Natur", "blume tier pflanze schmetterling"),
    "mui-energy-savings-leaf": de("Energiesparen", "blatt nachhaltig energie umwelt"),
    "mui-ev-station": de("E-Ladestation", "elektroauto laden strom tankstelle"),
    "mui-event-seat": de("Veranstaltungssitz", "sitzplatz event theater reservierung"),
    "mui-explore": de("Entdecken", "kompass erkunden reise orientierung"),
    "mui-factory": de("Fabrik", "industrie produktion werk gebäude"),
    "mui-feed": de("Neuigkeiten", "feed nachrichten artikel information"),
    "mui-fire-truck": de("Feuerwehr", "löschfahrzeug notfall brand feuer"),
    "mui-food-bank": de("Lebensmittelausgabe", "essen spende tafel lebensmittel"),
    "mui-garage": de("Garage", "auto parken stellplatz tor"),
    "mui-gas-meter": de("Gaszähler", "gas energie zähler verbrauch"),
    "mui-gite": de("Ferienunterkunft", "gîte ferienhaus unterkunft urlaub"),
    "mui-golf-course": de("Golfplatz", "golf sport kurs abschlag"),
    "mui-grass": de("Gras", "wiese garten natur rasen"),
    "mui-hail": de("Hagel", "wetter eis niederschlag sturm"),
    "mui-home-work": de("Homeoffice", "zuhause arbeit haus büro"),
    "mui-icecream": de("Eiscreme", "eis dessert süßspeise gelato"),
    "mui-iron": de("Bügeleisen", "bügeln wäsche kleidung haushalt"),
    "symbol-accessible-menu": de("Barrierefreies Menü", "zugänglich barrierefreiheit speisekarte inklusiv"),
    "symbol-activity-zone": de("Aktivitätsbereich", "zone aktivität freizeit spielfeld"),
    "symbol-artist": de("Künstler", "kunst maler kreativ person"),
    "symbol-award-meal": de("Ausgezeichnetes Essen", "preis mahlzeit restaurant gastronomie"),
    "symbol-barcode-scanner": de("Barcodescanner", "barcode code scanner kasse"),
    "symbol-barefoot": de("Barfuß", "fuß wellness strand spa"),
    "symbol-bath-outdoor": de("Außenbad", "badewanne draußen wellness spa"),
    "symbol-bath-private": de("Privatbad", "badezimmer privat zimmer dusche"),
    "symbol-beer-meal": de("Bier und Essen", "bier mahlzeit gastronomie pub"),
    "symbol-bike-dock": de("Fahrradstation", "rad stellplatz dock miete"),
    "symbol-bike-lane": de("Radweg", "fahrrad spur radfahren route"),
    "symbol-boat-bus": de("Bootsbus", "boot bus fähre transport"),
    "symbol-boat-railway": de("Boot und Bahn", "schiff zug fähre transport"),
    "symbol-books-movies-and-music": de("Bücher, Filme und Musik", "medien unterhaltung kultur bibliothek"),
    "symbol-bus-map-pin": de("Bushaltestelle", "bus karte pin station standort"),
    "symbol-cable-car": de("Seilbahn", "gondel berg lift transport"),
    "symbol-cake-add": de("Kuchen hinzufügen", "torte bestellen dessert geburtstag"),
    "symbol-calendar-check": de("Bestätigter Termin", "kalender haken gebucht verfügbar"),
    "symbol-calendar-clock": de("Terminzeit", "kalender uhr zeit planung"),
    "symbol-calendar-meal": de("Essenskalender", "kalender mahlzeit restaurant reservierung"),
    "symbol-camera-video": de("Videokamera", "video filmen kamera aufnahme"),
    "symbol-camping": de("Camping", "zelt campen draußen natur"),
    "symbol-carry-on-bag": de("Handgepäck", "koffer flug reise tasche"),
    "symbol-chair-counter": de("Thekenstuhl", "barhocker theke sitz stuhl"),
    "symbol-chair-fireplace": de("Sessel am Kamin", "stuhl feuer lounge gemütlich"),
    "symbol-chair-umbrella": de("Sitzplatz mit Schirm", "stuhl sonnenschirm terrasse strand"),
    "symbol-chef-hat": de("Kochmütze", "koch küche restaurant gastronomie"),
    "symbol-cleaning-bucket": de("Putzeimer", "reinigung housekeeping sauber wischen"),
    "symbol-cooking": de("Kochen", "küche herd essen zubereitung"),
    "symbol-dine-heart": de("Essen mit Herz", "restaurant liebe romantisch mahlzeit"),
    "symbol-eco": de("Umweltfreundlich", "eco nachhaltig natur grün"),
    "symbol-emergency-home": de("Notunterkunft", "notfall haus schutz unterkunft"),
    "symbol-event-list": de("Veranstaltungsliste", "event liste kalender termine"),
    "symbol-event-upcoming": de("Bevorstehende Veranstaltung", "event demnächst termin kalender"),
    "symbol-family-group": de("Familiengruppe", "familie personen kinder eltern"),
    "symbol-family-history": de("Familiengeschichte", "familie historie stammbaum generationen"),
    "symbol-family-home": de("Familienhaus", "familie zuhause kinder unterkunft"),
    "symbol-family-star": de("Familienfavorit", "familie stern empfohlen kinder"),
    "symbol-fire-check": de("Brandschutz geprüft", "feuer haken sicherheit kontrolliert"),
    "symbol-fire-hydrant": de("Hydrant", "feuerwehr wasser brandschutz notfall"),
    "symbol-fitness-tracker": de("Fitness-Tracker", "training aktivität schritte sport"),
    "symbol-flights-and-hotels": de("Flüge und Hotels", "flug hotel reise unterkunft"),
    "symbol-garden-cart": de("Gartenwagen", "garten karre pflanzen arbeit"),
    "symbol-globe-location-pin": de("Globaler Standort", "welt globus pin international"),
    "symbol-group-search": de("Gruppensuche", "gruppe personen suchen gäste"),
    "symbol-hand-meal": de("Servierte Mahlzeit", "hand essen service restaurant"),
    "symbol-gynecology": de("Gynäkologie", "frauenarzt medizin gesundheit behandlung"),
    "symbol-health-and-beauty": de("Gesundheit und Beauty", "wellness schönheit pflege kosmetik"),
    "symbol-health-cross": de("Gesundheitskreuz", "medizin erste hilfe klinik gesundheit"),
    "symbol-heart-check": de("Herz geprüft", "gesundheit liebe haken bestätigt"),
    "symbol-help-clinic": de("Hilfeklinik", "medizin hilfe klinik notfall"),
    "symbol-home-and-garden": de("Haus und Garten", "zuhause garten wohnen pflanzen"),
    "symbol-home-health": de("Gesundheit zu Hause", "haus pflege medizin zuhause"),
    "symbol-home-improvement-and-tools": de("Heimwerken", "werkzeug renovierung reparatur haus"),
    "symbol-home-pin": de("Unterkunftsstandort", "haus pin adresse zuhause"),
    "symbol-house-with-shield": de("Geschütztes Haus", "haus schild sicherheit schutz"),
    "symbol-household-supplies": de("Haushaltsbedarf", "haushalt reinigung vorräte zuhause"),
    "symbol-id-card": de("Ausweis", "identifikation karte mitarbeiter person"),
    "symbol-laundry": de("Wäscherei", "wäsche waschen reinigung kleidung"),
    "symbol-linked-services": de("Verknüpfte Dienste", "service verbunden integration leistungen"),
    "symbol-location-automation": de("Standortautomatisierung", "ort automation regel pin"),
    "symbol-location-home": de("Wohnort", "standort haus zuhause adresse"),
    "symbol-map-pin-heart": de("Lieblingsort", "karte pin herz favorit"),
    "symbol-map-pin-review": de("Bewerteter Ort", "karte pin bewertung rezension"),
    "symbol-map-search": de("Kartensuche", "karte suchen ort standort"),
    "symbol-massage": de("Massage", "spa wellness behandlung entspannung"),
    "symbol-meal-dinner": de("Abendessen", "mahlzeit dinner restaurant abend"),
    "symbol-meal-lunch": de("Mittagessen", "mahlzeit lunch restaurant mittag"),
    "symbol-medical-mask": de("Medizinische Maske", "mundschutz gesundheit hygiene medizin"),
    "symbol-mobile-ticket": de("Mobiles Ticket", "handy eintritt karte digital"),
    "symbol-mountain-flag": de("Bergziel", "berg flagge gipfel wandern"),
    "symbol-mountain-steam": de("Bergquellen", "berg dampf thermal wellness"),
    "symbol-movie-edit": de("Film bearbeiten", "video kino schneiden editieren"),
    "symbol-moving-beds": de("Betten verschieben", "bett zimmer umzug unterkunft"),
    "symbol-music-cast": de("Musik übertragen", "musik stream cast lautsprecher"),
    "symbol-outdoor-garden": de("Außengarten", "garten draußen natur terrasse"),
    "symbol-parent-child-dining": de("Essen mit Kindern", "eltern kind restaurant familie"),
    "symbol-parking-meter": de("Parkscheinautomat", "parken meter zahlung auto"),
    "symbol-parking-sign": de("Parkplatzschild", "parken schild stellplatz auto"),
    "symbol-partly-cloudy-day": de("Teilweise bewölkt", "wetter wolken sonne tag"),
    "symbol-passport": de("Reisepass", "pass reise ausweis international"),
    "symbol-person-apron": de("Person mit Schürze", "koch service mitarbeiter küche"),
    "symbol-person-celebrate": de("Feiernde Person", "party feiern veranstaltung gast"),
    "symbol-person-heart": de("Person mit Herz", "pflege liebe gast favorit"),
    "symbol-pet-supplies": de("Tierbedarf", "haustier hund katze futter"),
    "symbol-photo-prints": de("Fotoabzüge", "foto drucken bilder fotografie"),
    "symbol-playing-cards": de("Spielkarten", "karten spielen casino freizeit"),
    "symbol-sauna": de("Sauna", "wellness spa dampfbad entspannung"),
    "symbol-self-care": de("Selbstfürsorge", "pflege wellness beauty entspannung"),
    "symbol-service-toolbox": de("Service-Werkzeugkasten", "werkzeug service reparatur wartung"),
    "symbol-shopping-bag-speed": de("Express-Einkauf", "einkaufstasche schnell lieferung shopping"),
    "symbol-skillet": de("Pfanne", "kochen küche essen bratpfanne"),
    "symbol-snowflake": de("Schneeflocke", "schnee winter kalt klima"),
    "symbol-solo-dining": de("Allein essen", "einzelperson restaurant solo mahlzeit"),
    "symbol-sports-and-outdoors": de("Sport und Outdoor", "draußen aktivität freizeit bewegung"),
    "symbol-subway-walk": de("U-Bahn und Fußweg", "metro gehen route transport"),
    "symbol-transit-ticket": de("Nahverkehrsticket", "ticket bus zug transport karte"),
    "symbol-travel-luggage-and-bags": de("Reisegepäck", "koffer taschen reise gepäck"),
    "symbol-udon": de("Udon", "nudeln japanisch essen suppe"),
    "symbol-walk-bike": de("Zu Fuß und per Rad", "gehen fahrrad mobilität route"),
    "symbol-wall-art": de("Wandkunst", "bild dekoration kunst rahmen"),
    "symbol-water-bottle": de("Wasserflasche", "trinken flasche wasser hydration"),
};
